// extracted by mini-css-extract-plugin
export default {"loading":"XvRC6o","departmentHeader":"NVYAMb","list":"Vt0NYZ","department":"kbD8HF","job":"K0U9j5"};